import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import PopupV3 from '../../Popup/PopupV3';
import { SUBSCRIPTIONS_PATH } from '../../hooks/useStartPowerCheckout';

import styles from './resumePowerConfirmPopUp.scss';

const ResumePowerConfirmPopUp = ({ onCloseClick }) => {
    const history = useHistory();

    const handleResume = () => {
        onCloseClick();
        history.push(SUBSCRIPTIONS_PATH);
    };

    return (
        <PopupV3
            data-testid="modal.power-resume-confirm"
            className={styles.resumePopup}
            isOpen
            noIcon
            title="Resume Your Power Subscription"
            message="This feature is only available with an active Power subscription."
            showConfirmButton
            confirmButtonLabel="Resume"
            onConfirmClick={handleResume}
            showCancelButton
            cancelButtonLabel="Cancel"
            onCancelClick={onCloseClick}
            reverseButtonOrder
        />
    );
};

ResumePowerConfirmPopUp.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
};

export default ResumePowerConfirmPopUp;
